// @file: ead-ui/src/components/video/VideoPlayerAdmin.js
// Player de vídeo para administração
// - Desabilita legendas e atalhos de teclado para evitar erros quando não há trilhas
// - Usa IndigoPlayer com fonte fornecida via props

import React, { useEffect } from 'react';
import IndigoPlayer from 'indigo-player';
import 'indigo-player/lib/indigo-theme.css';

function VideoPlayerAdmin(props) {
  useEffect(() => {
    const element = document.getElementById('playerContainer');
    if (props.src) {
      let config = {
        autoplay: false,
        aspectRatio: 16 / 9,
        sources: [
          {
            type: props.type || 'dash',
            src: props.src,
          },
        ],
        ui: {
          locale: 'pt-BR',
          pip: true,
          // Evitar erros de legendas/atalhos quando não há trilhas
          subtitles: false,
          captions: false,
          keyboard: false,
        },
        thumbnails: {
          src: '',
        },
      };

      const _player = IndigoPlayer.init(element, config);

      // Evitar que erros internos do player interrompam a página
      try {
        _player.on('error', e => {
          // Silenciar erro de legendas/teclas quando não há trilhas
          // console.debug('[IndigoPlayer][error]', e);
        });
      } catch (e) {}

      return () => {
        _player.destroy();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.src]);

  return (
    <div id="playerContainer" style={{ width: `${props.width}vmin` }}></div>
  );
}

VideoPlayerAdmin.defaultProps = {
  src: String,
  type: String,
  width: Number,
  my_course_id: String,
  resource_id: String,
};

export default VideoPlayerAdmin;
